jQuery(function ($) {

	// ハンバーガーメニュー
	$(".js-trigger").on("click", function () {
		$(".l-header__burger").toggleClass("is_active");
		$(".js-burger-top").toggleClass("is_active");
		$(".js-burger-center").toggleClass("is_active");
		$(".js-burger-bottom").toggleClass("is_active");
		$(".js-menu").toggleClass("is_active");
	});
});
